import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { scrollToSection } from "@/lib/content";
import { useT } from "@/i18n";

export default function CookieBanner() {
  const { t } = useT();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("tb-cookies-accepted")) setVisible(true);
  }, []);

  if (!visible) return null;

  const accept = () => {
    localStorage.setItem("tb-cookies-accepted", "1");
    setVisible(false);
  };

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-24 sm:bottom-6 inset-x-4 sm:right-auto sm:left-6 sm:max-w-md z-40 bg-white/95 dark:bg-slate-900/95 backdrop-blur-xl border border-slate-200 dark:border-slate-700 rounded-2xl shadow-2xl p-5"
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg bg-slate-900/5 dark:bg-white/10 text-slate-700 dark:text-slate-200 flex items-center justify-center shrink-0">
          <Cookie size={17} />
        </div>
        <div>
          <div className="font-semibold text-sm">{t.cookies.title}</div>
          <p className="text-xs text-slate-500 dark:text-slate-400 leading-relaxed mt-1.5">{t.cookies.text}</p>
          <div className="mt-3 flex items-center gap-4">
            <button
              data-testid="cookie-accept-button"
              onClick={accept}
              className="bg-slate-900 hover:bg-slate-700 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-200 text-white text-xs font-semibold px-5 py-2 rounded-full transition-colors duration-200"
            >
              {t.cookies.accept}
            </button>
            <button
              data-testid="cookie-rodo-link"
              onClick={() => scrollToSection("#biuro-wirtualne-wiedza")}
              className="text-xs font-semibold text-slate-500 hover:text-slate-900 dark:hover:text-white transition-colors duration-200"
            >
              {t.cookies.rodo}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
